function getRandomProbablity() {
  return crypto.getRandomValues(new Uint32Array(1))[0] || 0;
}

export function generateRandomPassword(length: number): string {
  const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
  const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numberChars = "0123456789";
  const specialChars = "!@#$%^&*-_=+[]{}|;:,.<>?";

  const allChars = lowercaseChars + uppercaseChars + numberChars + specialChars;
  const passwordArray: string[] = [];

  // Ensure the password contains at least one character from each group
  passwordArray.push(
    lowercaseChars.charAt(getRandomProbablity() % lowercaseChars.length),
  );
  passwordArray.push(
    uppercaseChars.charAt(getRandomProbablity() % uppercaseChars.length),
  );
  passwordArray.push(
    numberChars.charAt(getRandomProbablity() % numberChars.length),
  );
  passwordArray.push(
    specialChars.charAt(getRandomProbablity() % specialChars.length),
  );

  // Fill the remaining password length with random characters from all groups
  for (let i = passwordArray.length; i < length; i++) {
    const randomIndex = getRandomProbablity() % allChars.length;
    passwordArray.push(allChars.charAt(randomIndex));
  }

  // Shuffle the array to ensure randomness of character order
  return passwordArray.sort(() => 0.5 - Math.random()).join("");
}
